import { render, staticRenderFns } from "./trainingReportSingle.vue?vue&type=template&id=15f88366"
import script from "./trainingReportSingle.vue?vue&type=script&lang=js"
export * from "./trainingReportSingle.vue?vue&type=script&lang=js"
import style0 from "./trainingReportSingle.vue?vue&type=style&index=0&id=15f88366&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports